import { render, staticRenderFns } from "./userReferralCodeAlias.vue?vue&type=template&id=30bc760e"
import script from "./userReferralCodeAlias.vue?vue&type=script&lang=js"
export * from "./userReferralCodeAlias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports